/**
 * Legacy prototype route redirects for backward compatibility only.
 *
 * Keep this list limited to pre-existing (unslugged) legacy/archived/shipped
 * prototype routes that now resolve to slug-prefixed App.tsx routes.
 *
 * All redirects are prefix-based: subpaths and query params are preserved.
 */
export interface PrototypeRouteRedirect {
  from: string;
  to: string;
}

export const prototypeRouteRedirects: PrototypeRouteRedirect[] = [
  {
    from: "/nh/slate-site-banner",
    to: "/ag/slate-site-banner",
  },
  {
    from: "/ji/savings-insights-2027",
    to: "/wa/savings-insights-2027",
  },
  {
    from: "/kg/brand-portal-homepage-redesign",
    to: "/kg/preactivation-homepage-v2",
  },
  {
    from: "/cart-substitutions-oos",
    to: "/sol/cart-substitutions-oos",
  },
  {
    from: "/cart/b_849zvhgyje",
    to: "/sol/cart-playground-duplicate",
  },
  {
    from: "/mobile-brand-nav-details",
    to: "/sol/mobile-brand-nav-details",
  },
  {
    from: "/search-grid-promoted-category-brand-shop",
    to: "/el/search-grid-promoted-category-brand-shop",
  },
  {
    from: "/brand-portal-feed-homepage-concepts",
    to: "/ad/brand-portal-feed-homepage-concepts",
  },
  {
    from: "/super-assistant-april-24-flash-session",
    to: "/ji/super-assistant-april-24-flash-session",
  },
  {
    from: "/faire-source-brand-cart-organization",
    to: "/jl/faire-source-cart-organization",
  },
  {
    from: "/homepage-net-terms-more-prominent",
    to: "/trp/homepage-net-terms-more-prominent",
  },
  {
    from: "/brand-ad-module-explorations",
    to: "/ac/brand-ad-module-explorations",
  },
  {
    from: "/ac/ad-carousel-on-catnav",
    to: "/ac/ad-carousel-on-hubs-exploration",
  },
  {
    from: "/search-grid-highly-rated-ads-carousel",
    to: "/el/search-grid-highly-rated-ads-carousel",
  },
  {
    from: "/search-grid-promoted-brand-row",
    to: "/el/search-grid-promoted-brand-row",
  },
  {
    from: "/super-assistant-mega-prototype",
    to: "/ji/super-assistant-mega-prototype",
  },
  // must be before /faire-source-cart
  {
    from: "/faire-source-cart-organization",
    to: "/jl/faire-source-cart-organization",
  },
  {
    from: "/search-grid-random-spanning-ads",
    to: "/el/search-grid-random-spanning-ads",
  },
  {
    from: "/faire/promoted-listings-budget-flex",
    to: "/tm/faire/promoted-listings-budget-flex",
  },
  {
    from: "/faire/ads-retailer-category-controls",
    to: "/tm/faire/ads-retailer-category-controls",
  },
  {
    from: "/brand-page-floating-sidebar",
    to: "/cc/brand-page-floating-sidebar",
  },
  { from: "/brand-portal-new-brands", to: "/mm/brand-portal-new-brands" },
  { from: "/fdxp-checkout-payment", to: "/kl/fdxp-checkout-payment" },
  // must be before /fd-invite-as-automation
  {
    from: "/fd-invite-as-automation/automations",
    to: "/aw/fd-invite-as-automation/automations",
  },
  {
    from: "/fulfillment-product-add-ons",
    to: "/mv/fulfillment-product-add-ons",
  },
  {
    from: "/resting-typeahead-suggestions",
    to: "/ad/resting-typeahead-suggestions",
  },
  { from: "/brand-portal-exploration", to: "/mm/brand-portal-exploration" },
  // must be before /cart
  { from: "/cart-save-for-later", to: "/bg/cart-save-for-later" },
  { from: "/faire-pay-invoice-clarity", to: "/hy/faire-pay-invoice-clarity" },
  { from: "/brand-portal-future", to: "/mm/brand-portal-future" },
  {
    from: "/message-reactions-dual-view",
    to: "/cw/message-reactions-dual-view",
  },
  { from: "/brand-page-exploration", to: "/cc/brand-page-exploration" },
  // must be before /search-refinement
  {
    from: "/search-refinement/find-similar",
    to: "/sc/search-refinement/find-similar",
  },
  {
    from: "/search-refinement/spa-gifts",
    to: "/sc/search-refinement/spa-gifts",
  },
  {
    from: "/faire-source-atc-confirmation",
    to: "/am/faire-source-atc-confirmation",
  },
  { from: "/search-ads-experiments", to: "/bri/search-ads-experiments" },
  { from: "/faire-pay-clarity-v2", to: "/hy/faire-pay-clarity-v2" },
  // must be before /og-index
  { from: "/og-index/experimental", to: "/ji/og-index/experimental" },
  { from: "/og-index/patterns", to: "/ji/og-index/patterns" },
  // must be before /ideas-v1
  { from: "/ideas-v1/saved/:boardId", to: "/rl/ideas-v1/saved/:boardId" },
  { from: "/ideas-v1/:themeId", to: "/rl/ideas-v1/:themeId" },
  { from: "/ideas-v1/ideas", to: "/rl/ideas-v1/ideas" },
  { from: "/ads-settings-history", to: "/il/ads-settings-history" },
  { from: "/all-categories-promoted", to: "/ua/all-categories-promoted" },
  {
    from: "/promoted-placement-scatter",
    to: "/bri/promoted-placement-scatter",
  },
  { from: "/search-popout-carousels", to: "/ua/search-popout-carousels" },
  { from: "/faire/ads-home-widget", to: "/tm/faire/ads-home-widget" },
  { from: "/my-orders-mental-model", to: "/am/my-orders-mental-model" },
  { from: "/new-cc-homepage-banner", to: "/ad/new-cc-homepage-banner" },
  { from: "/products-page-template", to: "/ad/products-page-template" },
  { from: "/pdp-refresh-iteration-r3", to: "/cc/pdp-refresh-iteration-r3" },
  { from: "/promoted-brand-banner", to: "/bri/promoted-brand-banner" },
  { from: "/ads-display-banner", to: "/pj/ads-display-banner" },
  { from: "/fd-invite-as-automation", to: "/aw/fd-invite-as-automation" },
  {
    from: "/brand-cart-organization",
    to: "/jl/faire-source-cart-organization",
  },
  { from: "/faire-source-cart", to: "/am/faire-source-cart" },
  { from: "/brand-storefronts", to: "/rl/brand-storefronts" },
  { from: "/brand-launches", to: "/ll/brand-launches" },
  { from: "/side-cart-exploration", to: "/am/side-cart-exploration" },
  { from: "/ads-social-feed", to: "/il/ads-social-feed" },
  { from: "/baseline-hack-test", to: "/am/baseline-hack-test" },
  { from: "/brand-livestream", to: "/bri/brand-livestream" },
  { from: "/catalog-scorecard", to: "/bb/catalog-scorecard" },
  { from: "/compass-pdp-rebuild", to: "/rl/compass-pdp-rebuild" },
  { from: "/fdxp-checkout", to: "/kl/fdxp-checkout" },
  { from: "/fs-cart-conversion", to: "/am/fs-cart-conversion" },
  { from: "/haunted-shelf-ads", to: "/bri/haunted-shelf-ads" },
  { from: "/mobile-web-canvas", to: "/rl/mobile-web-canvas" },
  { from: "/playground-v2", to: "/mj/playground-v2" },
  { from: "/product-tiles", to: "/sc/product-tiles" },
  { from: "/report-issues-flow", to: "/jb/report-issues-flow" },
  { from: "/search-refinement", to: "/sc/search-refinement" },
  { from: "/sidecart-saved-for-later", to: "/bg/sidecart-saved-for-later" },
  { from: "/sidecart-to-cart", to: "/rl/sidecart-to-cart" },
  { from: "/slate-table-test", to: "/ad/slate-table-test" },
  { from: "/trends-hub", to: "/cc/trends-hub" },
  { from: "/variant-switcher-v2", to: "/ji/variant-switcher-v2" },
  { from: "/video-ad-search", to: "/ka/video-ad-search" },
  { from: "/cc-review-products", to: "/ad/cc-review-products" },
  { from: "/cc-bulk-editor", to: "/ad/cc-bulk-editor" },
  { from: "/early-pay", to: "/ck/early-pay" },
  { from: "/fabio-test", to: "/fc/fabio-test" },
  { from: "/how-faire-works", to: "/kl/how-faire-works" },
  { from: "/ideas-v1", to: "/rl/ideas-v1" },
  { from: "/og-index", to: "/ji/og-index" },
  { from: "/onboarding", to: "/kl/onboarding" },
  { from: "/order-issue-response", to: "/jb/order-issue-response" },
  { from: "/product-tour", to: "/gk/product-tour" },
  { from: "/test-with-james", to: "/am/test-with-james" },
  { from: "/vibe-swipe", to: "/my/vibe-swipe" },
  { from: "/watson-test", to: "/am/watson-test" },
  { from: "/cart", to: "/rl/cart" },
  {
    from: "/compass-super-assistant-poc",
    to: "/ji/compass-super-assistant-poc",
  },
  {
    from: "/brand-nudges-missing-details-pdp-chat-messages",
    to: "/oo/brand-nudges-missing-details-pdp-chat-messages",
  },
  {
    from: "/send-inventory-flow/create/choose-products",
    to: "/kv/send-inventory-flow/create/choose-products",
  },
  {
    from: "/compasspanelexplorations/brand/:brandSlug",
    to: "/rl/compasspanelexplorations/brand/:brandSlug",
  },
  {
    from: "/non-faire-source-atc-shopping-loop-native",
    to: "/am/non-faire-source-atc-shopping-loop-native",
  },
  {
    from: "/brand-order-detail-animated-illustration",
    to: "/sag/brand-order-detail-animated-illustration",
  },
  {
    from: "/design-faire-com-v2/posts/normal-example",
    to: "/th/design-faire-com-v2/posts/normal-example",
  },
  {
    from: "/faire-source-atc-shopping-loop-native",
    to: "/am/faire-source-atc-shopping-loop-native",
  },
  {
    from: "/brand-funded-promo-modal-exploration",
    to: "/lb/brand-funded-promo-modal-exploration",
  },
  {
    from: "/design-faire-com-v2/posts/playground",
    to: "/th/design-faire-com-v2/posts/playground",
  },
  {
    from: "/faire/reactive-onboarding/:orderId",
    to: "/ji/faire/reactive-onboarding/:orderId",
  },
  {
    from: "/non-faire-source-atc-shopping-loop",
    to: "/am/non-faire-source-atc-shopping-loop",
  },
  {
    from: "/opening-soon-identity-verification",
    to: "/jb/opening-soon-identity-verification",
  },
  {
    from: "/send-inventory-flow/create/fragile",
    to: "/kv/send-inventory-flow/create/fragile",
  },
  {
    from: "/virtual-tradeshow/brand/:brandSlug",
    to: "/cwu/virtual-tradeshow/brand/:brandSlug",
  },
  {
    from: "/insider-enrollment-benefits-modal",
    to: "/ec/insider-enrollment-benefits-modal",
  },
  {
    from: "/send-inventory-flow/create/step-3",
    to: "/kv/send-inventory-flow/create/step-3",
  },
  {
    from: "/send-inventory-flow/create/step-4",
    to: "/kv/send-inventory-flow/create/step-4",
  },
  {
    from: "/compass-chat-interaction-details",
    to: "/ji/compass-chat-interaction-details",
  },
  {
    from: "/send-inventory-flow/add-products",
    to: "/kv/send-inventory-flow/add-products",
  },
  {
    from: "/updated-native-atc-shopping-loop",
    to: "/am/updated-native-atc-shopping-loop",
  },
  {
    from: "/abandoned-cart-automation-setup",
    to: "/lb/abandoned-cart-automation-setup",
  },
  {
    from: "/brand-page-navigation-deep-dive",
    to: "/sol/brand-page-navigation-deep-dive",
  },
  {
    from: "/compass-interaction-exploration",
    to: "/ji/compass-interaction-exploration",
  },
  {
    from: "/compasspanelexplorations/brands",
    to: "/rl/compasspanelexplorations/brands",
  },
  {
    from: "/faire/templates/orders/:orderId",
    to: "/ji/faire/templates/orders/:orderId",
  },
  {
    from: "/insider-enrollment-payment-flow",
    to: "/ml/insider-enrollment-payment-flow",
  },
  {
    from: "/retailer-onboarding-brand-match",
    to: "/sr/retailer-onboarding-brand-match",
  },
  {
    from: "/faire-source-atc-shopping-loop",
    to: "/am/faire-source-atc-shopping-loop",
  },
  {
    from: "/faire/false-out-of-stock-nudge",
    to: "/ad/faire/false-out-of-stock-nudge",
  },
  {
    from: "/compasspanelexplorations/cart",
    to: "/rl/compasspanelexplorations/cart",
  },
  {
    from: "/pack-shipment/v1/add-products",
    to: "/kv/pack-shipment/v1/add-products",
  },
  {
    from: "/pack-shipment/v2/add-products",
    to: "/kv/pack-shipment/v2/add-products",
  },
  {
    from: "/pdp/vanilla-bean-marshmallows",
    to: "/rl/pdp/vanilla-bean-marshmallows",
  },
  {
    from: "/super-assistant-entry-surface",
    to: "/ji/super-assistant-entry-surface",
  },
  {
    from: "/themes-r2-rl/cart/:brandToken",
    to: "/rl/themes-r2-rl/cart/:brandToken",
  },
  {
    from: "/atc-shopping-loop-end-to-end",
    to: "/am/atc-shopping-loop-end-to-end",
  },
  {
    from: "/brand-page-mobile-navigation",
    to: "/sol/brand-page-mobile-navigation",
  },
  {
    from: "/customer-detail-activity-log",
    to: "/ll/customer-detail-activity-log",
  },
  {
    from: "/faire/promoted-listings-2027",
    to: "/tm/faire/promoted-listings-2027",
  },
  {
    from: "/pdp/fletcher-lu-seed-cracker",
    to: "/rl/pdp/fletcher-lu-seed-cracker",
  },
  {
    from: "/pdp/momofuku-chili-chocolate",
    to: "/rl/pdp/momofuku-chili-chocolate",
  },
  {
    from: "/search/find-similar-ad-modal",
    to: "/ss/search/find-similar-ad-modal",
  },
  {
    from: "/brand/:brandSlug/logged-out",
    to: "/rl/brand/:brandSlug/logged-out",
  },
  {
    from: "/compass-drawer-overlay-demo",
    to: "/rl/compass-drawer-overlay-demo",
  },
  {
    from: "/faire/catalog-dashboard-fbf",
    to: "/kv/faire/catalog-dashboard-fbf",
  },
  {
    from: "/faire/templates/bulk-editor",
    to: "/ji/faire/templates/bulk-editor",
  },
  {
    from: "/retailer-flash-session-2-27",
    to: "/ji/retailer-flash-session-2-27",
  },
  {
    from: "/retroactive-insider-savings",
    to: "/et/retroactive-insider-savings",
  },
  {
    from: "/send-inventory-flow/billing",
    to: "/kv/send-inventory-flow/billing",
  },
  {
    from: "/themes-r2-rl/saved/:boardId",
    to: "/rl/themes-r2-rl/saved/:boardId",
  },
  { from: "/ads-2d-controls-alpha-beta", to: "/ac/ads-2d-controls-alpha-beta" },
  { from: "/brand-cart-overlay-concept", to: "/rl/brand-cart-overlay-concept" },
  { from: "/compass-ai-chat-pdp-inline", to: "/qh/compass-ai-chat-pdp-inline" },
  { from: "/external-retail-prices-pdp", to: "/bs/external-retail-prices-pdp" },
  { from: "/faire/proactive-faire-plus", to: "/ji/faire/proactive-faire-plus" },
  { from: "/logged-out-personalization", to: "/kl/logged-out-personalization" },
  { from: "/pack-shipment/add-products", to: "/kv/pack-shipment/add-products" },
  { from: "/pdp-infinite-scroll-mobile", to: "/cc/pdp-infinite-scroll-mobile" },
  {
    from: "/progressive-modals-insider",
    to: "/shc/progressive-modals-insider",
  },
  { from: "/r2b-referrals-now-on-faire", to: "/mm/r2b-referrals-now-on-faire" },
  { from: "/search-continuous-browsing", to: "/aj/search-continuous-browsing" },
  { from: "/send-inventory-flow/create", to: "/kv/send-inventory-flow/create" },
  { from: "/send-inventory-flow/drafts", to: "/kv/send-inventory-flow/drafts" },
  { from: "/cc-loading-modal-sequence", to: "/ad/cc-loading-modal-sequence" },
  { from: "/faire-source-non-insiders", to: "/am/faire-source-non-insiders" },
  { from: "/faire/reactive-onboarding", to: "/ji/faire/reactive-onboarding" },
  { from: "/feed-content-explorations", to: "/cc/feed-content-explorations" },
  { from: "/search-split-grid-results", to: "/sc/search-split-grid-results" },
  { from: "/upmarket-retailer-landing", to: "/ji/upmarket-retailer-landing" },
  { from: "/compasspanelexplorations", to: "/rl/compasspanelexplorations" },
  { from: "/faire/templates/products", to: "/ji/faire/templates/products" },
  { from: "/pack-shipment/v1/prepare", to: "/kv/pack-shipment/v1/prepare" },
  { from: "/pack-shipment/v2/prepare", to: "/kv/pack-shipment/v2/prepare" },
  { from: "/pdp-chat-missing-details", to: "/oo/pdp-chat-missing-details" },
  { from: "/pdp-refresh-iteration-r2", to: "/cc/pdp-refresh-iteration-r2" },
  { from: "/pdp/miso-caramel-popcorn", to: "/rl/pdp/miso-caramel-popcorn" },
  { from: "/profit-margin-calculator", to: "/bb/profit-margin-calculator" },
  { from: "/retailer-payment-balance", to: "/jb/retailer-payment-balance" },
  { from: "/unified-progress-tracker", to: "/ml/unified-progress-tracker" },
  { from: "/brand/audreys-home-gift", to: "/th/brand/audreys-home-gift" },
  { from: "/faire-pay-payment-modal", to: "/ck/faire-pay-payment-modal" },
  { from: "/faire/catalog-dashboard", to: "/bb/faire/catalog-dashboard" },
  { from: "/fd-website-setup-wizard", to: "/jt/fd-website-setup-wizard" },
  { from: "/fulfillment-bulk-editor", to: "/kv/fulfillment-bulk-editor" },
  { from: "/image-enrichment-nudges", to: "/oo/image-enrichment-nudges" },
  { from: "/product-category-picker", to: "/cw/product-category-picker" },
  { from: "/retailer-command-center", to: "/rg/retailer-command-center" },
  { from: "/updated-atc-interaction", to: "/am/updated-atc-interaction" },
  { from: "/brand-analytics-colors", to: "/th/brand-analytics-colors" },
  { from: "/brand-launch-highlight", to: "/ll/brand-launch-highlight" },
  { from: "/category/:categoryName", to: "/rl/category/:categoryName" },
  { from: "/compass-contained/home", to: "/rl/compass-contained/home" },
  { from: "/faire-checkout-replica", to: "/ck/faire-checkout-replica" },
  { from: "/faire/products-table-2", to: "/ad/faire/products-table-2" },
  { from: "/faire/review-to-accept", to: "/ji/faire/review-to-accept" },
  { from: "/faire/templates/orders", to: "/ji/faire/templates/orders" },
  { from: "/pdp-content-iterations", to: "/cc/pdp-content-iterations" },
  { from: "/pdp/sourdough-pretzels", to: "/rl/pdp/sourdough-pretzels" },
  { from: "/stepper-responsiveness", to: "/il/stepper-responsiveness" },
  { from: "/ads-profit-calculator", to: "/gb/ads-profit-calculator" },
  { from: "/brand-page-navigation", to: "/sol/brand-page-navigation" },
  { from: "/category-menu-styling", to: "/cc/category-menu-styling" },
  { from: "/compass-chat-behavior", to: "/rl/compass-chat-behavior" },
  { from: "/faire-pay-touchpoints", to: "/ck/faire-pay-touchpoints" },
  { from: "/global-navigation/pdp", to: "/cc/global-navigation/pdp" },
  { from: "/nux-category-selector", to: "/tc/nux-category-selector" },
  { from: "/pack-shipment/prepare", to: "/kv/pack-shipment/prepare" },
  { from: "/pdp-refresh-iteration", to: "/cc/pdp-refresh-iteration" },
  { from: "/pdp-v2-with-ai-inline", to: "/rl/pdp-v2-with-ai-inline" },
  { from: "/pdp-with-overlay-push", to: "/rl/pdp-with-overlay-push" },
  { from: "/themes-r2-rl/:themeId", to: "/rl/themes-r2-rl/:themeId" },
  { from: "/cancelled-order-view", to: "/gt/cancelled-order-view" },
  { from: "/index-exploration-v2", to: "/rl/index-exploration-v2" },
  { from: "/pdp-with-drawer-left", to: "/rl/pdp-with-drawer-left" },
  { from: "/ai-chat-exploration", to: "/ji/ai-chat-exploration" },
  { from: "/brand/:brandSlug/v2", to: "/rl/brand/:brandSlug/v2" },
  { from: "/design-faire-com-v2", to: "/th/design-faire-com-v2" },
  { from: "/search/find-similar", to: "/sc/search/find-similar" },
  { from: "/send-inventory-flow", to: "/kv/send-inventory-flow" },
  { from: "/starter-collections", to: "/cw/starter-collections" },
  { from: "/bulk-upload-export", to: "/ad/bulk-upload-export" },
  { from: "/collection-creator", to: "/ji/collection-creator" },
  {
    from: "/compass-buying-assistant",
    to: "/ji/compass-buying-assistant",
  },
  { from: "/faire-forecast-hub", to: "/sag/faire-forecast-hub" },
  { from: "/faire-source-about", to: "/am/faire-source-about" },
  { from: "/fulfillment-funnel", to: "/kv/fulfillment-funnel" },
  { from: "/inventory-insights", to: "/ad/inventory-insights" },
  { from: "/my-orders-batching", to: "/am/my-orders-batching" },
  { from: "/order-confirmation", to: "/rl/order-confirmation" },
  { from: "/savings-visibility", to: "/et/savings-visibility" },
  { from: "/themes-r2-rl/ideas", to: "/rl/themes-r2-rl/ideas" },
  { from: "/themes-r2-rl/saved", to: "/rl/themes-r2-rl/saved" },
  { from: "/atc-toast-non-pdp", to: "/am/atc-toast-non-pdp" },
  { from: "/brand-add-product", to: "/ll/brand-add-product" },
  { from: "/brand-shop-page-2", to: "/ms/brand-shop-page-2" },
  { from: "/compass-prototype", to: "/ji/compass-prototype" },
  { from: "/editorial-content", to: "/cwu/editorial-content" },
  { from: "/faire-source-card", to: "/am/faire-source-card" },
  { from: "/faire/bulk-editor", to: "/ji/faire/bulk-editor" },
  { from: "/global-navigation", to: "/cc/global-navigation" },
  { from: "/ideas-r3/:themeId", to: "/rl/ideas-r3/:themeId" },
  { from: "/index-exploration", to: "/rl/index-exploration" },
  { from: "/insider-side-cart", to: "/at/insider-side-cart" },
  { from: "/multi-turn-search", to: "/sc/multi-turn-search" },
  { from: "/nux/business-type", to: "/cw/nux/business-type" },
  { from: "/prototype-starter", to: "/at/prototype-starter" },
  { from: "/retail-growth-jam", to: "/ji/retail-growth-jam" },
  { from: "/search-results-v2", to: "/rl/search-results-v2" },
  {
    from: "/sidecart-quantity-picker",
    to: "/bg/sidecart-quantity-picker",
  },
  { from: "/themes-r2-rl/cart", to: "/rl/themes-r2-rl/cart" },
  { from: "/themes/all-ideas2", to: "/rl/themes/all-ideas2" },
  { from: "/virtual-tradeshow", to: "/cwu/virtual-tradeshow" },
  { from: "/brand-join-nudge", to: "/kc/brand-join-nudge" },
  { from: "/brand/:brandSlug", to: "/rl/brand/:brandSlug" },
  { from: "/faire/faire-plus", to: "/ji/faire/faire-plus" },
  { from: "/pricing-insights", to: "/bb/pricing-insights" },
  { from: "/ads-2d-controls", to: "/ac/ads-2d-controls" },
  { from: "/brand-marketing", to: "/ll/brand-marketing" },
  { from: "/brands-on-faire", to: "/shc/brands-on-faire" },
  { from: "/faire/analytics", to: "/ms/faire/analytics" },
  { from: "/grid-refinement", to: "/cc/grid-refinement" },
  { from: "/image-upscaling", to: "/bh/image-upscaling" },
  { from: "/next-gen-search", to: "/ss/next-gen-search" },
  { from: "/pdp-chat-feb-24", to: "/ji/pdp-chat-feb-24" },
  { from: "/pdp-with-drawer", to: "/rl/pdp-with-drawer" },
  { from: "/themes/:themeId", to: "/rl/themes/:themeId" },
  { from: "/ai-bulk-editor", to: "/al/ai-bulk-editor" },
  { from: "/brand-products", to: "/ll/brand-products" },
  { from: "/chart-movement", to: "/il/chart-movement" },
  { from: "/faire-pay-test", to: "/ck/faire-pay-test" },
  { from: "/faire/messages", to: "/ms/faire/messages" },
  { from: "/faire/products", to: "/ms/faire/products" },
  { from: "/ideas-r3/ideas", to: "/rl/ideas-r3/ideas" },
  { from: "/intrater-top-5", to: "/ji/intrater-top-5" },
  { from: "/pdp-v2-with-ai", to: "/rl/pdp-v2-with-ai" },
  { from: "/search-results", to: "/rl/search-results" },
  { from: "/brand-banners", to: "/rt/brand-banners" },
  { from: "/homepage-q226", to: "/kl/homepage-q226" },
  { from: "/live-shopping", to: "/ky/live-shopping" },
  { from: "/multistep-kyb", to: "/ck/multistep-kyb" },
  { from: "/pack-shipment", to: "/kv/pack-shipment" },
  { from: "/pdp/bjornqorn", to: "/rl/pdp/bjornqorn" },
  { from: "/product-setup", to: "/kv/product-setup" },
  { from: "/ready-to-list", to: "/ad/ready-to-list" },
  { from: "/table-builder", to: "/ad/table-builder" },
  { from: "/themes-r2-rl", to: "/rl/themes-r2-rl" },
  { from: "/themes/ideas", to: "/rl/themes/ideas" },
  { from: "/lj-pdp/cart", to: "/lj/lj-pdp/cart" },
  { from: "/pdp-refresh", to: "/rl/pdp-refresh" },
  { from: "/pdp-mobile", to: "/sc/pdp-mobile" },
  { from: "/ideas-hub", to: "/hp/ideas-hub" },
  { from: "/checkout", to: "/rl/checkout" },
  { from: "/combobox", to: "/gk/combobox" },
  { from: "/v2-toolbar", to: "/gk/v2-toolbar" },
  { from: "/homepage", to: "/cc/homepage" },
  { from: "/ideas-r3", to: "/rl/ideas-r3" },
  { from: "/new-page", to: "/rl/new-page" },
  { from: "/template", to: "/rl/template" },
  { from: "/lj-pdp", to: "/lj/lj-pdp" },
  { from: "/orders", to: "/ad/orders" },
  { from: "/pdp-v2", to: "/rl/pdp-v2" },
  { from: "/themes", to: "/rl/themes" },
  { from: "/b2buy", to: "/ji/b2buy" },
  { from: "/pdp", to: "/rl/pdp" },
  { from: "/brand-ad-module-explorations", to: "/ac/ad-search-results" },
];
